import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ImageGallery from 'react-image-gallery'
import { getPower } from 'core/utils/cultures/car'
import { isSubjectToSoh } from 'core/utils/enums/genericFuels'
import { FormattedDate, FormattedMessage, injectIntl } from 'react-intl'
import { isMobile } from 'react-device-detect'
import { Row, Col, ButtonPrimary, ButtonGhost } from 'core/components/ui'
import SVG from 'core/components/svg'
import ImagePlaceholder from 'core/components/image-placeholder'
import svg from 'assets/svg'
import { font, greys, fontFamily } from 'assets/themes/theme-default'
import GalleryWrapper from './GalleryWrapper'

const RenderVisuVehicle = styled(Row)`
  margin: 0 auto;
  overflow: hidden;
  img {
    max-width: 100%;
  }
`
const ImagePlaceholderWrapper = styled.div`
  width: 250px;
  height: 250px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 300px;
`

const RowData = styled(Row)`
  margin: 10px;
`
const ColIconWrapper = styled(Col)`
  text-align: right;
`

const Icon = styled(SVG)`
  width: 24px;
  height: 24px;
  fill: ${greys.dark1};
  vertical-align: middle;
`

const PrincipalInfos = styled.div`
  /* padding-bottom: 20px;*/
  border-bottom: 1px solid ${greys.dark3};
  color: ${greys.dark1};
`
const SecondaryInfos = styled.div`
  padding-top: 20px;
  font-size: ${font.size.sm};
`
const ColDivider = styled(Col)`
  border-right: 1px solid ${greys.dark3};
`

const NumberplateWrapper = styled.div`
  color: ${greys.dark3};
  font-size: ${font.size.base};
`
const MakeVersionTrimWrapper = styled.div`
  color: ${greys.dark1};
`
const Makerapper = styled.div`
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
  font-size: ${font.size.lgsm};
  margin: ${isMobile ? '0px' : '0 8px 0 0'};
  line-height: ${isMobile && 'normal'};
`
const VersionWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.italic.name},`}
    ${fontFamily.italic};
  font-size: ${font.size.lgxs};
  margin: ${isMobile ? '0px' : '5px 0'};
  line-height: ${isMobile && 'normal'};
`
const TrimWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.normal.name},`}
    ${fontFamily.normal};
  font-size: ${font.size.base};
  line-height: ${isMobile && 'normal'};
`

const PricesWrapper = styled.div`
  font-size: ${font.size.xs};
  line-height: ${font.size.sm};
  color: ${greys.dark3};
  text-align: center;
  padding: ${isMobile ? '0 0 5px 0' : '0 0 15px 0'};
`

const LabelValuePriceWrapper = styled(Row)`
  margin: 5px 0;
`
const ColValuePrice = styled(Col)`
  text-align: right;
`

const ColLabelPrice = styled(Col)`
  text-align: left;
`
const VehicleInfoPrice = styled.div`
  margin: 0 0 45px 0;
  color: ${greys.dark3};
  padding: ${isMobile ? '15px' : '15px 30px'};
  font-size: ${font.size.xs};
  text-align: center;
  > span > span {
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
      ${fontFamily.bold};
  }
`

/*const ColLabelTotalPrice = styled(ColLabelPrice)`
  color: ${greys.dark1};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.base};
`
const ColValueTotalPrice = styled(ColValuePrice)`
  color: ${props => props.theme.colors.color1.bg};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.base};
`*/

const RenderRow = ({ label, icon }) => (
  <RowData type="flex" gutter={20} align="middle">
    <ColIconWrapper span={6}>
      <Icon svg={icon} />
    </ColIconWrapper>
    <Col span={18}>{label}</Col>
  </RowData>
)

RenderRow.propTypes = {
  label: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.node]).isRequired,
  icon: PropTypes.shape().isRequired
}

const VehicleDetail = props => {
  const {
    vehicle,
    tradeInprice,
    activateNextStep,
    showDetailPrice,
    price,
    intl,
    previousWizard
  } = props
  const {
    dateOfRegistration,
    numberplate,
    make,
    version,
    energy,
    trim,
    urlImage,
    body,
    horsePower,
    taxPower,
    kilowatt,
    gearBoxType,
    doors,
    prices
  } = vehicle
  const { totalOptionsPrice, totalServiceContractsPrice, totalPaintPrice, totalSaddleries } = prices
  const renderPrice = (label, value) => (
    <>
      {value > 0 && (
        <LabelValuePriceWrapper type="flex" gutter={20}>
          <ColLabelPrice span={16}>{label}</ColLabelPrice>
          <ColValuePrice span={8}>{value}</ColValuePrice>
        </LabelValuePriceWrapper>
      )}
    </>
  )
  /* const RenderTotalPrice = () => (
    <LabelValuePriceWrapper type="flex" gutter={20}>
      <ColLabelTotalPrice span={16}>Total</ColLabelTotalPrice>
      <ColValueTotalPrice span={8}>{totalPrice}</ColValueTotalPrice>
    </LabelValuePriceWrapper>
  )

   {<RenderTotalPrice />}

  */
  return (
    <>
      <Row type="flex" gutter={20}>
        <Col lg={isMobile ? 24 : 12} xs={24}>
          <PrincipalInfos>
            {numberplate && <NumberplateWrapper>{numberplate}</NumberplateWrapper>}
            <MakeVersionTrimWrapper>
              <Makerapper>{make}</Makerapper>
              <VersionWrapper>{version}</VersionWrapper>
              <TrimWrapper>{trim}</TrimWrapper>
            </MakeVersionTrimWrapper>
            {prices && showDetailPrice && (
              <PricesWrapper>
                {renderPrice(intl.formatMessage({ id: 'prewiew-vehicle-price-1' }), price)}
                {renderPrice(
                  intl.formatMessage({ id: 'prewiew-vehicle-price-2' }),
                  totalOptionsPrice
                )}
                {renderPrice(
                  intl.formatMessage({ id: 'prewiew-vehicle-price-3' }),
                  totalServiceContractsPrice
                )}
                {renderPrice(
                  intl.formatMessage({ id: 'prewiew-vehicle-price-4' }),
                  totalPaintPrice
                )}
                {renderPrice(
                  intl.formatMessage({ id: 'prewiew-vehicle-price-5' }),
                  totalSaddleries
                )}
              </PricesWrapper>
            )}
          </PrincipalInfos>

          <SecondaryInfos>
            <Row type="flex">
              <Col span="10">
                {body && <RenderRow label={body} icon={svg.bodies.sedan} />}
                {
                  <RenderRow
                    label={getPower(taxPower, horsePower, kilowatt).complete}
                    icon={svg.power}
                  />
                }
                {energy && <RenderRow label={energy} icon={svg.gas_pump} />}
              </Col>
              <ColDivider span={1} offset={1} />
              <Col span="11" offset="1">
                {gearBoxType && <RenderRow label={gearBoxType} icon={svg.gearbox} />}
                {doors && (
                  <RenderRow
                    label={intl.formatMessage(
                      { id: 'stock-vehicle-detail-list-infos-doors-value' },
                      { doors }
                    )}
                    icon={svg.doors}
                  />
                )}
                {dateOfRegistration && (
                  <RenderRow
                    label={<FormattedDate value={dateOfRegistration} />}
                    icon={svg.calendar}
                  />
                )}
              </Col>
            </Row>
          </SecondaryInfos>
        </Col>
        <Col lg={isMobile ? 24 : 12} xs={24}>
          {vehicle && vehicle.pictures && vehicle.pictures.length > 0 ? (
            <GalleryWrapper>
              <ImageGallery
                showPlayButton={false}
                items={[
                  {
                    original: `${urlImage}?width=550`,
                    fullscreen: `${urlImage}`,
                    thumbnail: `${urlImage}?width=100`
                  },
                  ...vehicle.pictures.map(x => ({
                    original: `${x.pictureUrl}&width=550`,
                    fullscreen: x.pictureUrl,
                    thumbnail: x.fileUrl
                  }))
                ]}
                showBullets
                showThumbnails={false}
              />
            </GalleryWrapper>
          ) : (
            <RenderVisuVehicle type="flex" align="middle" justify="center">
              <>
                {urlImage ? (
                  <img
                    src={`${urlImage}?width=450&height=300`}
                    alt={`${make} ${version} ${trim || ''}`}
                  />
                ) : (
                  <ImagePlaceholderWrapper>
                    <ImagePlaceholder />
                  </ImagePlaceholderWrapper>
                )}
              </>
            </RenderVisuVehicle>
          )}
          {vehicle && tradeInprice && (
            <>
              <VehicleInfoPrice>
                <FormattedMessage
                  id="tradeIn-estimate-vehicle-price-legend"
                  values={{
                    expirationDate: (
                      <span>
                        {intl.formatDate(tradeInprice.offerValidityDate, {
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric'
                        })}
                      </span>
                    )
                  }}
                />{' '}
                {isSubjectToSoh(vehicle.energyId) && (
                  <FormattedMessage id="tradeIn-estimate-vehicle-price-legend-soh" />
                )}
              </VehicleInfoPrice>
              {previousWizard && tradeInprice && (
                <Row type="flex" gutter={30}>
                  <Col span={12}>
                    <ButtonPrimary onClick={() => activateNextStep(false)} block>
                      <FormattedMessage id="tradeIn-estimate-fundingConfigurator-button" />
                    </ButtonPrimary>
                  </Col>
                  <Col span={12}>
                    <ButtonGhost onClick={() => activateNextStep(true)} block>
                      <FormattedMessage id="tradeIn-estimate-finalizationConfigurator-button" />
                    </ButtonGhost>
                  </Col>
                </Row>
              )}
            </>
          )}
        </Col>
      </Row>
    </>
  )
}

VehicleDetail.defaultProps = {
  vehicle: null,
  showDetailPrice: true,
  price: null,
  tradeInprice: null,
  previousWizard: null
}

VehicleDetail.propTypes = {
  intl: PropTypes.shape().isRequired,
  vehicle: PropTypes.shape(),
  showDetailPrice: PropTypes.bool,
  price: PropTypes.number,
  tradeInprice: PropTypes.shape(),
  previousWizard: PropTypes.string,
  activateNextStep: PropTypes.func
}

export default injectIntl(VehicleDetail)
